import { ChartHeading as ChartHeadingBase, ChartHeadingProps } from '@/components/Charts/components/ChartHeading';

export const ChartHeading = ({ ...props }: ChartHeadingProps) => {
  return <ChartHeadingBase {...props} />;
};
